import React, { Component } from "react";
import { Table } from "antd";
import { number, string } from "prop-types";
import axios from "axios";
import { MENU_KEYS } from "../constants";

class InfoTable extends Component {
  state = {
    tableHeight: this.props.tableHeight,
    data: [],
    // objects: {
    // 	raw: [],
    // 	//processed: []
    // },
    page: {
      loading: true,
      error: false
    },
    filteredInfo: null,
    sortedInfo: null
  };

  componentWillMount() {
    const idToken = localStorage.getItem("id_token");
    //add id token before requests tp header
    window.axiosClient.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${idToken}`;
  }
  // handleChange = (pagination, filters, sorter) => {
  //  // console.log("Various parameters", pagination, filters, sorter);
  //   this.setState({
  //     filteredInfo: filters,
  //     sortedInfo: sorter
  //   });
  // };

  // clearFilters = () => {
  //   this.setState({ filteredInfo: null });
  // };
  // clearAll = () => {
  //   this.setState({
  //     filteredInfo: null,
  //     sortedInfo: null
  //   });
  // };
  // // setAgeSort = () => {
  // 	this.setState({
  // 		sortedInfo: {
  // 			order: 'descend',
  // 			columnKey: 'age',
  // 		},
  // 	});
  // }

  fetchData = props => {
    const { menuKey } = props;
    let url = "";
    switch (menuKey) {
      case MENU_KEYS.FINANCIAL_ELEMENTS:
      case MENU_KEYS.UNITS_ELEMENTS:
        url = "/core_objects?objectType=unit";
        break;
      case MENU_KEYS.SYSTEM_ELEMENTS:
        url = "/core_objects?objectType=system";
        break;
      case MENU_KEYS.INTERCONN_ELEMENTS:
        url = "/core_objects?objectType=interconn";
        break;
      case MENU_KEYS.LOAD_ELEMENTS:
        url = "/core_objects?objectType=load";
        break;

      case MENU_KEYS.SYSTEM_VARIABLES:
      case MENU_KEYS.UNITS_VARIABLES:
      case MENU_KEYS.INTERCONN_VARIABLES:
      case MENU_KEYS.LOAD_VARIABLES:
        url = "/core_init_data";
        break;
      case MENU_KEYS.FINANCIAL_VARIABLES:
        url = "/variables";
        break;
      default:
        console.error("url not set in fetch data for menu key" + menuKey);
        break;
    }

    if (url !== "") return window.axiosClient.get(url);
    return null;
  };

  componentWillReceiveProps(nextProps) {
    //load data
    const { menuKey } = nextProps;
    const self = this;
    axios
      .all([this.fetchData(nextProps)])
      .then(
        axios.spread(function(dataResponse) {
          let data = null;
          switch (menuKey) {
            case MENU_KEYS.SYSTEM_VARIABLES:
              data = dataResponse.data.system_variables;
              break;
            case MENU_KEYS.UNITS_VARIABLES:
              data = dataResponse.data.unit_variables;
              break;
            case MENU_KEYS.INTERCONN_VARIABLES:
              data = dataResponse.data.interconn_variables;
              break;
            case MENU_KEYS.LOAD_VARIABLES:
              data = dataResponse.data.load_variables;
              break;

            case MENU_KEYS.UNITS_ELEMENTS:
            case MENU_KEYS.FINANCIAL_VARIABLES:
            default:
              data = dataResponse.data;
              break;
          }
          self.setState(prevState => ({
            ...prevState,
            page: {
              ...prevState.page,
              loading: false
            },
            data: data
            // objects: {
            // 	...prevState.objects,
            // 	raw: objectsResponse.data
            // }
          }));
        })
      )
      .catch(error => {
        console.error("Error occurred loading page", error);
        self.setState(prevState => ({
          page: {
            ...prevState.page,
            loading: false,
            error: true,
            "error-msg": error.message
          }
        }));
      });
  }

  getFilters = key => {
    const { data } = this.state;
    let filters = [];
    data.forEach(item => {
      const value = item[key];
      if (value && !filters.filter(f => f.value === value)[0])
        filters.push({ text: value, value: value });
    });

    //sort alphabetically on text
    filters = filters.sort((a, b) => a.text.localeCompare(b.text));
    return filters;
  };

  getFcasFilters = () => {
    const { data } = this.state;
    let filters = [];
    data.forEach(item => {
      const serviceStr = item["list_of_fcas_services"];
      if (serviceStr) {
        const services = serviceStr.split(",");
        services.forEach(s => {
          if (!filters.filter(f => f.value === s)[0])
            filters.push({ text: s, value: s });
        });
      }
    });
    //	console.log('fcas filters', filters);
    //sort alphabetically on text
    filters = filters.sort((a, b) => a.text.localeCompare(b.text));
    return filters;
  };

  getColumnsDefinitions = menuKey => {
    switch (menuKey) {
      case MENU_KEYS.SYSTEM_ELEMENTS:
      case MENU_KEYS.INTERCONN_ELEMENTS:
      case MENU_KEYS.LOAD_ELEMENTS:
        return [
          {
            title: <b>Element</b>,
            dataIndex: "text"
          },
          {
            title: <b>Element no</b>,
            dataIndex: "value"
          }
        ];

      case MENU_KEYS.FINANCIAL_VARIABLES:
      case MENU_KEYS.SYSTEM_VARIABLES:
      case MENU_KEYS.UNITS_VARIABLES:
      case MENU_KEYS.LOAD_VARIABLES:
      case MENU_KEYS.INTERCONN_VARIABLES:
        return [
          {
            title: <b>Variable</b>,
            dataIndex: "text",
            width: 300
          },
          {
            title: <b>Field name</b>,
            dataIndex: "value",
            width: 200
          },
          {
            title: <b>Units</b>,
            dataIndex: "units",
            width: 100
          },
          {
            title: <b>Description</b>,
            dataIndex: "description"
          }
        ];
      case MENU_KEYS.UNITS_ELEMENTS:
      case MENU_KEYS.FINANCIAL_ELEMENTS:
        return [
          {
            title: <b>Region</b>,
            dataIndex: "regionid",
            filters: this.getFilters("regionid"),
            onFilter: (value, record) => record.regionid === value,
            sorter: (a, b) => a.regionid.localeCompare(b.regionid)
          },
          {
            title: <b>Portfolio</b>,
            dataIndex: "portfolioid",
            filters: this.getFilters("portfolioid"),
            onFilter: (value, record) => record.portfolioid === value,
            sorter: (a, b) => a.portfolioid.localeCompare(b.portfolioid)
          },
          {
            title: <b>Station</b>,
            dataIndex: "stationid",
            filters: this.getFilters("stationid"),
            onFilter: (value, record) => record.stationid === value,
            sorter: (a, b) => a.stationid.localeCompare(b.stationid)
          },
          {
            title: <b>Duid name</b>,
            dataIndex: "duid_name",
            filters: this.getFilters("duid_name"),
            onFilter: (value, record) => record.duid_name === value,
            sorter: (a, b) => a.duid_name.localeCompare(b.duid_name)
          },
          {
            title: <b>Element no</b>,
            dataIndex: "element_no",
            key: "element_no",
            sorter: (a, b) => a.element_no - b.element_no
            //sortOrder: sortedInfo.columnKey === "element_no" && sortedInfo.order
          },
          {
            title: <b>Fuel type</b>,
            dataIndex: "fuel_type",
            filters: this.getFilters("fuel_type"),
            onFilter: (value, record) => record.fuel_type === value,
            sorter: (a, b) => {
              const fuelA = a.fuel_type ? a.fuel_type : "";
              const fuelB = b.fuel_type ? b.fuel_type : "";
              return fuelA.localeCompare(fuelB);
            }
          },
          {
            title: <b>Fuel cost</b>,
            dataIndex: "fuel_cost",
            sorter: (a, b) => a.fuel_cost - b.fuel_cost
          },
          {
            width: 600,
            title: <b>FCAS services</b>,
            dataIndex: "list_of_fcas_services",
            filters: this.getFcasFilters(),
            onFilter: (value, record) =>
              record.list_of_fcas_services &&
              record.list_of_fcas_services.indexOf(value) >= 0
            // sorter: (a, b) =>
            //   a.list_of_fcas_services.localeCompare(b.list_of_fcas_services)
          }
        ];
      default:
        console.error(
          "Column definitions not specified for menu key:",
          menuKey
        );
        return "";
    }
  };

  render() {
    const { data, tableHeight } = this.state;
    const { menuKey } = this.props;
    //  console.log("info table", this.state, this.props);

    return (
      <div>
        <Table
          dataSource={data}
          columns={this.getColumnsDefinitions(menuKey)}
          pagination={false}
          scroll={{ x: true, y: tableHeight }}
          size="small"
          bordered={true}
          rowKey={(record, index) => `row-${index}`}
          loading={this.state.page.loading}
          //onChange={this.handleChange}
        />
      </div>
    );
  }
}

InfoTable.propTypes = {
  tableHeight: number.isRequired,
  menuKey: string.isRequired
};

export default InfoTable;



// WEBPACK FOOTER //
// ./src/views/info/info_table/InfoTable.jsx